import { render, staticRenderFns } from "./FootnotesForm.vue?vue&type=template&id=0bd90050"
import script from "./FootnotesForm.vue?vue&type=script&lang=js"
export * from "./FootnotesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports